import React, { useEffect, useState } from "react";
import { makeStyles, Grid } from "@material-ui/core";

import { useQuery } from "@apollo/client";

import { GET_SCHDULES_LIMIT } from "../../../../../../quries/schedule";
import Schedule from "./Schedule";

const useStyles = makeStyles((theme) => ({}));

interface ScheduleListProps {
  //   title: string;
  //   date: string;
}

function ScheduleList({}: ScheduleListProps) {
  const classes = useStyles();
  const [state, setState] = useState<any>(null);
  const { loading, data, error } = useQuery(GET_SCHDULES_LIMIT, {
    // pollInterval: 2000,
    fetchPolicy: "no-cache",
    variables: {
      limit: 6,
      //   start: (match.params.pageIndex - 1) * 10,
      sort: "schedule_date:DESC",
    },
  });

  useEffect(() => {
    console.log(data);
    if (data && data.schedules) {
      //   let schedules = data.schedules;
      setState(data.schedules);
    }
    return () => {
      setState(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.schedules) {
    console.log(error);
  }

  if (state && state.length > 0) {
    return (
      <Grid xs={12} item container component={"ul"} style={{ paddingLeft: 0 }}>
        {state.length > 0 ? (
          state.map((element: any, index: any) => {
            console.log(element);
            return (
              //   <div></div>
              <Schedule
                key={`main-schdule-list-${element.idNum}-${index}`}
                idNum={element.id}
                title={element.schedule_text}
                date={element.schedule_date}
              />
            );
          })
        ) : (
          <div></div>
        )}
      </Grid>
    );
  } else {
    return <div></div>;
  }
}

// export default MainContainer;
export default ScheduleList;
